import { ACTION_TYPES, NOTIFICATION } from 'constants/MeshbotConstant';

export const getUIForwardNotificationsBlock = (id, item) => {
    return {
        id,
        name: ACTION_TYPES.FORWARD_NOTIFICATIONS,
        selectedFieldTrigger: NOTIFICATION,
        blocks: [item],
    };
};
